import { useDispatch } from "react-redux";
import showToast from "../../Hooks/toast";
import {setSendData} from "../../../Store/Slice/scheduleSlice";
import {useGetVerificationTextMutation} from "../../../Store/Builder/schedule.api";

const useGetVerificationTextApi = () => {
  const dispatch = useDispatch();
  const [getText] = useGetVerificationTextMutation();

  const get = () => {
    getText()
      .unwrap()
      .then((res) => {
        dispatch(setSendData({verification_text: res?.verification_text}))

      })
      .catch((err) => {
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetVerificationTextApi;
